import { render, staticRenderFns } from "./SampleProfileView.vue?vue&type=template&id=2b72c37a&"
import script from "./SampleProfileView.vue?vue&type=script&lang=ts&"
export * from "./SampleProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports